import { useState, useEffect } from "react";
import { Sparkles, X, ArrowRight } from "lucide-react";

const promos = [
  {
    icon: "🎯",
    text: "FREE Career Wheel Assessment — Discover Your Blind Spots in 5 Minutes",
    cta: "Get Access Code",
    href: "#career-wheel",
  },
  {
    icon: "✨",
    text: "Complimentary 45-Min Coaching Clarity Call — Only 5 Spots Weekly!",
    cta: "Reserve Now",
    href: "#clarity-call",
  },
  {
    icon: "🚀",
    text: "Feeling Stuck? Unlock Your Next Big Career Move — 100% Free Consultation",
    cta: "Apply Today",
    href: "#clarity-call",
  },
];

const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [currentPromo, setCurrentPromo] = useState(0);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("promoBannerDismissed");
    if (dismissed === "true") {
      setIsVisible(false);
    }
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setCurrentPromo((prev) => (prev + 1) % promos.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [isVisible]);

  const handleDismiss = () => {
    setIsVisible(false);
    sessionStorage.setItem("promoBannerDismissed", "true");
  };

  const handleClick = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (!isVisible) return null;

  const promo = promos[currentPromo];

  return (
    <div
      data-testid="promo-banner"
      className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-primary via-primary/90 to-primary text-white shadow-md"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-2.5 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <Sparkles className="h-4 w-4 flex-shrink-0 hidden md:block animate-pulse" />
          <div 
            key={currentPromo}
            className="flex items-center gap-2 flex-1 min-w-0 animate-fade-in-up"
          >
            <span className="text-xl flex-shrink-0">{promo.icon}</span>
            <p className="text-xs md:text-sm font-medium truncate md:whitespace-normal">
              {promo.text}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-2 flex-shrink-0">
          <button
            onClick={() => handleClick(promo.href)}
            data-testid="promo-cta-btn"
            className="hidden sm:flex items-center gap-1 bg-white text-primary px-3 py-1 rounded-full text-xs font-bold hover:bg-white/90 transition-colors"
          >
            {promo.cta}
            <ArrowRight className="h-3 w-3" />
          </button>
          <button
            onClick={() => handleClick(promo.href)}
            data-testid="promo-cta-mobile"
            className="sm:hidden bg-white text-primary px-3 py-1 rounded-full text-xs font-bold"
          >
            Go
          </button>
          <button
            onClick={handleDismiss}
            data-testid="promo-dismiss-btn"
            className="p-1 hover:bg-white/20 rounded-full transition-colors"
            aria-label="Close promotional banner"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Progress Dots */}
      <div className="flex justify-center gap-1 pb-1">
        {promos.map((_, i) => (
          <div
            key={i}
            className={`h-1 rounded-full transition-all duration-500 ${
              i === currentPromo ? "w-6 bg-white" : "w-1.5 bg-white/40"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default PromoBanner;
